import axios from 'axios';
import appLogger from '../../utils/logging';

const eventsservice = axios.create({
  baseURL: `${process.env.REACT_APP_AUTH_SERVICE_BASE_URL}public/events/`,
});

const eventsservicegetquestionnaire = axios.create({
  baseURL: `${process.env.REACT_APP_AUTH_SERVICE_BASE_URL}api/v1/public`,
});

const paymentService = axios.create({
  baseURL: `${process.env.REACT_APP_PAYMENT_SERVICE_URL}`,
});

const couponService = axios.create({
  baseURL: `${process.env.REACT_APP_COUPON_SERVICE_URL}`,
});

const getEventDetails = (id: string) =>
  eventsservice.get(`${id}`).catch((err) => {
    return err;
  });

const sendRegistrationDetails = (eventKey: any, body: any) => {
  return eventsservice.post(`${eventKey}/registrations`, body);
};

const getUserDetails = (body: any) => {
  return eventsservice.get(`registrations/${body.eventRegistrationId}`);
};

const getConferenceRegistration = (body: any) => {
  return eventsservice.post(
    `registrations/${body.eventRegistrationId}/conferences/${body.conferenceKey}`,
  );
};

const cancelRegisteredEvent = (eventRegistrationId: string) =>
  eventsservice.delete(`registrations/${eventRegistrationId}`);

const getQuestionnaire = async (questionnaireKey: string, locale: string) => {
  const endpoint = `/questionnaires/${questionnaireKey}`;
  const options = {
    headers: { 'Accept-Language': locale },
  };
  try {
    return await eventsservicegetquestionnaire.get(endpoint, options);
  } catch (error: any) {
    const fullURL = `${eventsservicegetquestionnaire.defaults.baseURL}${endpoint}`;
    appLogger.error('Error on API Request:', 'url =', fullURL, 'error =', error);
    throw error;
  }
};

const getPaymentDetails = (eventId: string) => {
  return paymentService.get(`/prices/products/g2w/referenceKeys/${eventId}`);
};

const checkCouponExists = (eventId: string) => {
  return couponService.get(`/associations/products/g2w/references/${eventId}/exists`);
};

const validateCoupon = (payload: any) => {
  const body = { alias: payload.promoCode };
  return couponService.post(`/coupons/products/g2w/references/${payload.eventKey}/validate`, body);
};

const API = {
  getEventDetails,
  sendRegistrationDetails,
  getUserDetails,
  getConferenceRegistration,
  cancelRegisteredEvent,
  getQuestionnaire,
  getPaymentDetails,
  checkCouponExists,
  validateCoupon,
};

export default API;
